<template>
  <section v-if="hasEnoughData || $isPageEditing" class="related-links">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <sc-text tag="h2" class="font-l related-links__title" :field="fields.title" />
          <ul class="related-links__item-wrapper">
            <sc-placeholder name="related-links-placeholder" :rendering="rendering" />
          </ul>
          <span v-if="!hasEnoughData">At least 1 link is required to render the component</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { Placeholder as ScPlaceholder, Text as ScText } from '@sitecore-jss/sitecore-jss-vue';

const props = defineProps({
  rendering: {
    type: Object,
    default: () => ({}),
  },
  fields: {
    type: Object,
    default: () => ({}),
  },
  params: {
    type: Object,
    default: () => ({}),
  },
});

const visibleLinks = computed(
  () =>
    props.rendering?.placeholders?.['related-links-placeholder']?.filter(
      (link) =>
        link.componentName === 'RelatedLinksItem' &&
        link.dataSource &&
        link.fields?.link?.value?.href &&
        link.fields?.link?.value?.text
    ) ?? []
);
const hasEnoughData = computed(() => visibleLinks.value.length > 0);
</script>

<style lang="scss">
@import './scss/RelatedLinks.scss';
</style>
